import { create } from 'zustand';

const EnvStore = create((set) => ({
  setSecret: (secret) => set(() => {
    secret?.callback?.();
    return { ...secret };
  }),
}));

export default EnvStore;
